import { render, staticRenderFns } from "./ckList.vue?vue&type=template&id=16820d03&scoped=true&"
import script from "./ckList.vue?vue&type=script&lang=js&"
export * from "./ckList.vue?vue&type=script&lang=js&"
import style0 from "./ckList.vue?vue&type=style&index=0&id=16820d03&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16820d03",
  null
  
)

export default component.exports